<div bsModal
     #raterTypesForModal="bs-modal"
     id="raterTypesForModal"
     class="modal fade"
     (onShown)="onShown('rtfm')"
     role="dialog"
     aria-labelledby="raterTypesForModal"
     aria-hidden="true"
     [config]="{backdrop: 'static'}">

    <div class="modal-dialog">

        <div #modalContent class="modal-content">
            <div class="modal-header text-center">
                <button type="button" class="close" (click)="close()" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
                <h2 class="modal-title text-center">Relationships</h2>
            </div>

            <div class="modal-body">
                <div *ngIf="!loading; else load">
                    <div class="d-sm-flex align-items-center justify-content-between mb-4 margin-bottom">
                        <p></p>
                        <div class="btns-container">
                            <a (click)="openModal('New', 0, '' )" 
                               class="d-none d-sm-inline-block btn btn-sm btn-primary shadow-sm"
                               [ngClass]="{'btn-primary': !isStandard, 'btn-gray': isStandard}">
                                <i class="fas fa-plus text-white-50"> <span class="button-text">Create Relationship</span></i>
                            </a>
                        </div>
                    </div>


                    <div class="rater-types-modal">
                        <ul class="tab-nav">
                            <li (click)="loadData(2)" class="active"><a data-toggle="tab">Standard Relationships</a></li><!--standart rater types-->
                            <li (click)="loadData(1)"><a data-toggle="tab">Custom Relationships</a></li><!--my rater types-->
                        </ul>
                    </div>

                    <div class="main-tab-content tab-content">
                        <div style="width: 100%; max-height: 400px; height:400px;">
                            <ag-grid-angular #agGrid
                                             style="width: 100%; height: 100%;"
                                             class="ag-theme-balham"
                                             [floatingFilter]="true"
                                             [gridOptions]="gridOptions"
                                             [rowData]="raterTypesData"
                                             [columnDefs]="raterTypesDataHeaders"
                                             (rowClicked)="onRaterTypesRowClicked($event)"
                                             (gridReady)="onRaterTypesGridReady($event)"
                                             [pagination]="true"
                                             [paginationPageSize]="25"
                                             [overlayNoRowsTemplate]="overlayNoRowsTemplate"
                                             [rowSelection]="rowSelection"
                                             (selectionChanged)="onSelectionChanged($event)">
                            </ag-grid-angular>
                        </div>
                    </div>
                </div>

                <ng-template #load>
                    <div class="text-center">
                        <i class="fa fa-spinner fa-pulse fa-3x fa-fw" style="color:#46a8ce; font-size: 75px;"></i>
                        <p>Loading, please wait...</p>
                    </div>
                </ng-template>
            </div>
        </div>
    </div>
</div>

<!--NEW-EDIT RATER MODAL-->
<div class="rtfm">
    <div id="rtcreateEditModal" class="modal fade" tabindex="-1" role="dialog">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h2 class="modal-title text-center">{{action}} Relationship</h2>
                    <button type="button" (click)="closeModal()" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>

                <div class="modal-body">

                    <div class="row" style="margin-bottom: 10px; margin-top: -5px;">
                        <div class="align-items-center justify-content-between d-sm-flex align-items-center justify-content-between mb-4">
                            <div>
                                <a></a>
                            </div>
                            <div>
                                <!--<button (click)="closeModal()" type="button" class="btn btn-secondary">Cancel</button>-->
                                <a *ngIf="action == 'Edit'" (click)="openConfirmationModal()" style="margin-left: 25px;" class="d-none d-sm-inline-block btn btn-sm btn-red shadow-sm margin-right-5">
                                    <i class="fas fa-trash text-white-50"> <span class="button-text">Delete</span></i>
                                </a>
                                <a (click)="saveRaterType()" class="d-none d-sm-inline-block btn btn-sm btn-primary shadow-sm   ">
                                    <i class="fas fa-save text-white-50"> <span class="button-text">Save</span></i>
                                </a>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-xs-12 col-md-2">
                            <label>Name:</label>
                        </div>
                        <div class="col-xs-12 col-md-10" style="padding: 0;">
                            <input #ratertName
                                   id="raterName"
                                   (keypress)="preventSpace(ratertName.value, $event, 'raterName')"
                                   [(ngModel)]="name"
                                   placeholder="Name"
                                   type="text"
                                   name="name"
                                   value="" />
                        </div>
                    </div>
                    <!--<div class="row">
                        <div class="col-xs-12 col-md-2">
                            <label>Min:</label>
                        </div>
                        <div class="col-xs-12 col-md-10" style="padding: 0;">
                            <input #ratertMin
                                   id="raterMin"
                                   (keypress)="preventSpace(ratertName.value, $event, 'Min')"
                                   [(ngModel)]="min"
                                   min="0"
                                   type="number"
                                   name="min"
                                   value="" />
                        </div>
                    </div>-->

                </div>

                <div class="modal-footer">
                    <div class="row">
                        <div class="col-md-12">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!--/*CONFIRMATION DELETE MODAL*/-->
<div class="rtfm">
    <div id="confirmationDeleteModal" class="modal fade" tabindex="-1" role="dialog">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h2 class="modal-title text-center">Delete Relationship</h2>

                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>

                <div class="modal-body text-center">
                    <p>Are you sure you want to delete this <b>Relationship</b>?</p>
                </div>

                <div class="modal-footer">
                    <div class="row">
                        <div class="col-md-12">
                            <button data-dismiss="modal" type="button" class="btn btn-secondary">Cancel</button>
                            <button (click)="deleteRaterType()" type="button" class="btn btn-primary">Ok</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>